import { Schema, number, string } from 'lib/schema';

export default class ShowStatsListens extends Schema {
  @string id;

  @number total;

  @number last24hours;

  @number trend24hours;

  @number last7days;

  @number trend7days;

  @number last30days;

  @number trend30days;
}
